<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
  >
    <path
      fill="currentColor"
      d="M17.525 4.466a.75.75 0 1 0 1.45.388l.646-2.415a.75.75 0 1 0-1.448-.388zM24.78 3.22a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0M22.5 9.752a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75M14.249 26a4.75 4.75 0 0 1-4.068-2.296l-2.01 1.006a2.75 2.75 0 0 1-3.174-.516l-1.19-1.19a2.75 2.75 0 0 1-.516-3.174l7.155-14.31a2.75 2.75 0 0 1 4.404-.714l8.345 8.345a2.75 2.75 0 0 1-.715 4.404l-3.827 1.913A4.75 4.75 0 0 1 14.25 26m3.056-5.857L11.53 23.03a3.25 3.25 0 0 0 5.776-2.888"
    />
  </svg>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'FluentMegaphoneLoud28Filled',
})
</script>
